import { render, staticRenderFns } from "./AppDashboard.vue?vue&type=template&id=445ac3ee&scoped=true"
import script from "./AppDashboard.vue?vue&type=script&lang=js"
export * from "./AppDashboard.vue?vue&type=script&lang=js"
import style0 from "./AppDashboard.vue?vue&type=style&index=0&id=445ac3ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445ac3ee",
  null
  
)

export default component.exports